import FavouriteItemCustom from "@features/favourite/favourite-item-custom";
import * as React from "react";
import { useWishlistStore } from "@features/favourite/wishlist-store";
import type { ProductType } from "@type/global";

function FavouriteList({ product }: { product: ProductType }) {
  const wishlist = useWishlistStore((state) => state.wishlist);
  return (
    <>
      {wishlist?.map((item) => (
        <FavouriteItemCustom key={item.id} wishlistItem={item} product={product} isSelectable />
      ))}
    </>
  );
}
export default FavouriteList;
